var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var defaultMessages = require('../../i18n/messages/default');
var SetLoginPreferences = require('./SetLoginPreferences.js');
var LoginPrefsLoading = require('./LoginPrefsLoading.js');
var IFrameManager = require('../../Auth/IFrameManager/iFrameManager.js').default;
var oAuthConstants = require('../../Auth/oAuthConstants.js');
var OidcManager = require('../../Auth/oidcManager.js').default;
var TokenStore = require('../../Auth/TokenStore/tokenStore.js').default;
var LoginActions = require('../../actions/LoginActions');
var { isEmpty } = require('lodash');


class LoginPrefs extends React.Component {
  constructor(props) {
    super(props);
    this._readCookieStatus = this.readCookieStatus.bind(this);
    this._receiveCookieStatus = this.receiveCookieStatus.bind(this);
    this._receiveSessionStatus = this.receiveSessionStatus.bind(this);
    this._readSessionStatus = this.readSessionStatus.bind(this);
    this._onSilentAuthSuccess = this.onSilentAuthSuccess.bind(this);
    this._onSilentAuthError = this.onSilentAuthError.bind(this);
    this._checkStatus = this.checkStatus.bind(this);
    this._oidcManager = new OidcManager(oAuthConstants);
    this._iFrameManager = IFrameManager();

    this.state = {
      renderloginPreference: false,
      idToken: '',
      decodedIdToken: {},
      localeId: this.props.localeId
    };
  }

  componentDidMount() {
    //load iframe check_cookie_iframe to check cookie exists or not
    this._iFrameManager.loadCheckCookieIFrame(oAuthConstants.authority, this._readCookieStatus, this._receiveCookieStatus);
    if (typeof window !== 'undefined') {
      window.addEventListener('onSilentAuthSuccess', this._onSilentAuthSuccess);
      window.addEventListener('onSilentAuthError', this._onSilentAuthError);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('onSilentAuthSuccess', this._onSilentAuthSuccess);
    window.removeEventListener('onSilentAuthError', this._onSilentAuthError);
  }

  onSilentAuthSuccess() {
    var accessToken = TokenStore.getAccessToken();
    if (!isEmpty(accessToken)) {
      this.setState({
        idToken: accessToken,
        decodedIdToken: TokenStore.readIdToken() || {}
      });
      this.setState({ renderloginPreference: true });
      //load check_session_iframe to monitor the session 
      this._iFrameManager.loadCheckSessionIFrame(oAuthConstants.authority, this._readSessionStatus, this._receiveSessionStatus);
    }
  }

  onSilentAuthError(e) {
    console.log("onSilentAuthError e.details: ", e.detail);
    const redirectTo = this.props.redirectUrl;
    LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.msg_cannot_open']), "error", true);
    setTimeout(function () { window.location.href = redirectTo }, 3000);
  }

  readCookieStatus() {
    setTimeout(() => {
      this._iFrameManager.checkCookieStatus();
    }, 300);
  }

  receiveCookieStatus(cookieStatus) {
    console.log("cookieStatus: ", cookieStatus)
    if (cookieStatus == 'exists')
      //cookie found start silent authetication process
      this._oidcManager.silentRenew();
    else
      //Cookie not found redirect back user to target application
      window.location.href = this.props.redirectUrl;
  }

  readSessionStatus() {
    //this is a false positive from synopsys
    this._checkStatus;
    setInterval(this._checkStatus, 1000 * 3);
  }

  checkStatus() {
    this._iFrameManager.checkSessionIFrameStatus();
  }

  receiveSessionStatus(sessionStatus) {
    console.log("sessionStatus: ", sessionStatus);
    if (sessionStatus != 'unchanged') {
      window.location.href = this.props.redirectUrl;
      // const redirectTo = this.props.redirectUrl;
      // LoginActions.triggerToast("It seems you are logged off from target application, please login first to your application and then try with Login Preferences.", "success", true);
      // setTimeout(function () { window.location.href = redirectTo }, 3000);
    }
    // else if(sessionStatus == 'changed') {  
    //   //this._oidcManager.silentRenew();
    //    const redirectTo = this.props.redirectUrl;
    //    LoginActions.triggerToast("It seems you are logged off from target application, please login first and then try with Login Preferences.", "error", true);
    //    setTimeout(function () { window.location.href = redirectTo }, 3000);
    // }

  }


  render() {
    let props = this.props;

    if (this.state.renderloginPreference) {
      return (
        <div>
          <SetLoginPreferences {...props}
            idToken={this.state.idToken}
            decodedIdToken={this.state.decodedIdToken}
            clientId={oAuthConstants.clientId}
          />
        </div>
      );
    }
    else {
      return (
        <LoginPrefsLoading {...props}/>
      )
    }
  }
}

module.exports = injectIntl(LoginPrefs)